export const MULTI_QUESTIONS_TYPE = {
  PAN: "pan",
  NAME: "name",
  DOB: "dob",
  STATE: "state",
  GSTIN: "gstin",
  GST_NAME: "gst_name",
  GST_ADDRESS: "gst_address",
};

// ---------- Question Type Mapping ----------
export const CUSTOM_QUESTION_TYPES_ID = {
  PARAGRAPH_TEXT: 1,
  SINGLE_SELECT_DROPDOWN: 2,
  MULTI_SELECT_DROPDOWN: 3,
  CALENDAR: 4,
  FILE: 5,
  SHORT_TEXT: 9,
  NUMBER: 10,
  URL: 11,
  GENDER: 12,
  INDIAN_STATE: 13,
  INDIAN_CITY: 14,
  PHONE: 15,
  PAN: 17,
  GST: 18,
};

export const PAN_QUESTION_MULTI_QUESTIONS = [
  {
    type: "pan",
    question: "PAN Number",
    is_visible: true,
    is_mandatory: true,
    disabled: true,
  },
  {
    type: "name",
    question: "Full Name on PAN",
    is_visible: true,
    is_mandatory: true,
  },
  {
    type: "dob",
    question: "DOB on PAN",
    is_visible: true,
    is_mandatory: true,
  },
  {
    type: "state",
    question: "State",
    is_visible: true,
    is_mandatory: true,
  },
  {
    type: "marital_status",
    question: "Marital Status",
    is_visible: true,
    is_mandatory: true,
  },
];

export const GST_QUESTION_MULTI_QUESTIONS = [
  {
    type: "gst_name",
    question: "Company name",
    is_visible: true,
    is_mandatory: true,
  },
  {
    type: "gstin",
    question: "GST Number",
    is_visible: true,
    is_mandatory: true,
    disabled: true,
  },
  {
    type: "gst_address",
    question: "Company address",
    is_visible: true,
    is_mandatory: true,
  },
  {
    type: "gst_pincode",
    question: "Company pincode",
    is_visible: true,
    is_mandatory: true,
  },
];
